import { StatsigClient } from '@statsig/react-bindings'

import { STATSIG_EXPERIMENTS, STATSIG_EXPERIMENTS_BUCKETS } from '@src/config/statsig-experiments.config'

import { statsigExperimentManager } from './statsig-experiment.manager'

/**
 * Resolves Meta Pixel autoConfig for the main-thread flow.
 * Control and every unresolved state retain the current enabled behavior;
 * only the exact Test bucket disables autoConfig.
 */
export const getFbPixelAutoConfigExperimentValue = (): boolean => {
  if (typeof window === 'undefined') return true

  try {
    const experimentName = STATSIG_EXPERIMENTS.FB_PIXEL_AUTOCONFIG
    const experiment = StatsigClient.instance().getExperiment(experimentName)

    if (experiment.groupName) {
      statsigExperimentManager.setExposedBuckets(
        [
          {
            experimentName,
            bucketName: experiment.groupName,
            isActive: experiment.__evaluation?.is_experiment_active ?? false,
          },
        ],
        false,
      )
    }

    return experiment.groupName !== STATSIG_EXPERIMENTS_BUCKETS.TEST_CAP
  } catch {
    return true
  }
}
